import type { Product } from "@shopify/hydrogen/storefront-api-types";
import { Separator } from "@components/atoms/separator/index.client";
import { Link, Money } from "@shopify/hydrogen";

export function ProductSearch({
  product,
  onRedirect,
}: {
  product: Product;
  onRedirect?: () => void;
}) {
  return (
    <Link
      to={`/products/${product.handle}`}
      onClick={onRedirect}
      className="flex gap-x-7 items-center w-full h-[76px] sm:h-[155px]"
    >
      <img
        src={product.media.nodes[0].previewImage?.url}
        alt={product.media.nodes[0].alt ?? ""}
        className="min-w-[76px] w-[76px] sm:min-w-[155px] sm:w-[155px] h-full object-contain border border-custom-light-gray border-solid"
      />
      <div>
        <h1 className="uppercase text-xs sm:text-xl">{product.title}</h1>
        <Separator className="mt-1 sm:mt-1.5 mb-[5.5px] sm:mb-[10px]" />
        <span
          className="text-[10px] sm:text-xs overflow-hidden text-ellipsis leading-none sm:leading-3"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
          }}
        >
          {product.description}
        </span>
        <Money
          data={product.variants.nodes[0].priceV2}
          className="text-custom-dark-blue text-xs sm:text-xl mt-1.5 sm:mt-3"
        />
      </div>
    </Link>
  );
}
